import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IconComponent } from '@gains-com/ui-angular';
import { LottieAnimationComponent } from '../../lottie-animation/lottie-animation.component.js';

/**
 * The centered lottie/icon status block shared by the purchase/merch status
 * cards. The ac-flex/ac-ctr wrapper lives inside this template so the shared
 * styles.scss structural selectors keep matching after conversion.
 */
@Component({
  selector: 'app-payment-status-indicator',
  imports: [LottieAnimationComponent, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="ac-flex ac-ctr">
      @switch (visual()) {
        @case ('complete') {
          <app-lottie-animation [size]="132" path="payments_complete" [loop]="false" />
        }
        @case ('blocked') {
          <app-lottie-animation [size]="132" path="payments_blocked" [loop]="false" />
        }
        @case ('failed') {
          <ac-icon iconKey="payment:fail" [size]="132" />
        }
        @default {
          <app-lottie-animation [size]="132" path="payments_pending" />
        }
      }
    </div>
  `
})
export class PaymentStatusIndicatorComponent {
  /** purchase_status / redemption_status / merch view status; unknown or null renders as pending. */
  readonly status = input<string | null>();

  // aborted (redemption flows) renders as failed so the redemption status
  // cards can convert later without touching this component.
  protected readonly visual = computed<'complete' | 'blocked' | 'failed' | 'processing'>(() => {
    switch (this.status()) {
      case 'complete':
        return 'complete';
      case 'blocked':
        return 'blocked';
      case 'failed':
      case 'aborted':
        return 'failed';
      default:
        return 'processing';
    }
  });
}
